export const accountStatusPopupMessages = [
    {
        status: 'statusBankruptcy',
        logEvent: {
            screen: {
                type: 'Dashboard Screen',
                action: 'BankruptcyDashboardDisplayed',
                description: 'Dashboard displayed for Bankruptcy'
            }
        },
        popupTemplate: {
            metadata: {
                slotProps: {
                    root: {
                        sx: {
                            '.MuiDialogTitle-root': {
                                fontFamily: 'Poppins',
                                fontWeight: '400 !important'
                            },
                            '.MuiDialogContent-root': {
                                padding: '0px !important'
                            }
                        }
                    },
                    paragraph: {
                        variant: 'paragraph',
                        sx: {
                            color: '#536371',
                            textAlign: 'left',
                            margin: '2rem !important',
                            '& b': {
                                color: '#12202C',
                                fontWeight: '500'
                            },
                            '& u': {
                                color: '#00476A',
                                fontWeight: '500'
                            }
                        }
                    },
                    multiparagraph: {
                        variant: 'paragraph',
                        sx: {
                            color: '#536371',
                            textAlign: 'left',
                            margin: '0 2rem 2rem !important',
                            '& b': {
                                color: '#12202C',
                                fontWeight: '500'
                            },
                            '& u': {
                                color: '#00476A',
                                fontWeight: '500',
                                display: {
                                    xs: 'none',
                                    sm: 'inline-block',
                                    md: 'inline-block',
                                    lg: 'inline-block',
                                    xl: 'inline-block'
                                }
                            },
                            '& a': {
                                color: '#00476A',
                                fontWeight: '500',
                                display: {
                                    xs: 'inline-block',
                                    sm: 'none',
                                    md: 'none',
                                    lg: 'none',
                                    xl: 'none'
                                }
                            }
                        }
                    },
                    heading: {
                        variant: 'subtitle1',
                        sx: {
                            fontFamily: 'Poppins',
                            fontWeight: '600 !important',
                            textAlign: 'center',
                            margin: '0 32px',
                            color: '#12202C'
                        }
                    },
                    icon: {
                        sx: {
                            width: '200px',
                            height: '61.35px',
                            marginTop: '64px',
                            marginBottom: '32px',
                            justifyContent: 'center'
                        }
                    },
                    buttonCTA1: {
                        sx: {
                            color: '#FFFFFF',
                            fontFamily: 'Poppins !important',
                            width: {
                                xs: '100%',
                                sm: 'auto'
                            }
                        }
                    }
                }
            },
            body: [
                {
                    type: 'icon',
                    content: 'FreedomGold'
                },
                {
                    type: 'heading',
                    content: 'Your Account Is In Bankruptcy'
                },
                {
                    content: 'If you are represented by counsel, <b>they must authorize any direct communication</b> Freedom has with you.',
                    type: 'paragraph'
                },
                {
                    content: 'If your attorney has not authorized direct communication, please <b>contact your attorney first</b>.',
                    type: 'multiparagraph'
                },
                {
                    content:
                        'If your bankruptcy attorney has made such authorization, please <b>call Customer Care at</b> <a class="tag-event" href="tel:855-690-5900">855-690-5900</a><u>855-690-5900</u> to discuss your account. Our representatives are available to assist you Monday through Friday from 8:00am – 8:00pm and Saturday from 9:00am – 2:00pm Eastern Time.',
                    type: 'multiparagraph'
                }
            ]
        }
    },
    {
        status: 'statusLossMitigation',
        logEvent: {
            screen: {
                type: 'Dashboard Screen',
                action: 'LossMitigationDashboardDisplayed',
                description: 'Dashboard displayed for Loss Mitigation'
            }
        },
        popupTemplate: {
            metadata: {
                slotProps: {
                    root: {
                        sx: {
                            '.MuiDialogTitle-root': {
                                fontFamily: 'Poppins',
                                fontWeight: '400 !important'
                            },
                            '.MuiDialogContent-root': {
                                padding: '0px !important'
                            }
                        }
                    },
                    paragraph: {
                        variant: 'paragraph',
                        sx: {
                            color: '#536371',
                            textAlign: 'left',
                            margin: '2rem !important',
                            '& b': {
                                color: '#12202C',
                                fontWeight: '500'
                            },
                            '& u': {
                                color: '#00476A',
                                fontWeight: '500',
                                display: {
                                    xs: 'none',
                                    sm: 'inline-block',
                                    md: 'inline-block',
                                    lg: 'inline-block',
                                    xl: 'inline-block'
                                }
                            },
                            '& a': {
                                color: '#00476A',
                                fontWeight: '500',
                                display: {
                                    xs: 'inline-block',
                                    sm: 'none',
                                    md: 'none',
                                    lg: 'none',
                                    xl: 'none'
                                }
                            }
                        }
                    },
                    heading: {
                        variant: 'subtitle1',
                        sx: {
                            fontFamily: 'Poppins',
                            fontWeight: '600 !important',
                            textAlign: 'center',
                            margin: '0 32px',
                            color: '#12202C'
                        }
                    },
                    subHeading: {
                        variant: 'subtitle2',
                        sx: {
                            color: '#12202C',
                            fontWeight: '600 !important',
                            margin: '2rem 2rem 0 !important',
                            textAlign: 'left',
                            fontFamily: 'Poppins'
                        }
                    },
                    icon: {
                        sx: {
                            width: '200px',
                            height: '61.35px',
                            marginTop: '64px',
                            marginBottom: '32px',
                            justifyContent: 'center'
                        }
                    },
                    buttonCTA1: {
                        sx: {
                            color: '#FFFFFF',
                            fontFamily: 'Poppins !important',
                            width: {
                                xs: '100%',
                                sm: 'auto'
                            }
                        }
                    }
                }
            },
            body: [
                {
                    type: 'icon',
                    content: 'FreedomGold'
                },
                {
                    type: 'heading',
                    content: 'Your Account Is Active In Loss Mitigation'
                },
                {
                    type: 'subHeading',
                    content: 'If you would like to schedule a payment, please select "Pay Now" to make a one-time payment.'
                },
                {
                    content:
                        'If you have any questions or require further assistance, please <b>call Freedom Customer Care Department at</b> <a class="tag-event" href="tel:855-690-5900">855-690-5900</a><u>855-690-5900</u>. Our representatives are available to assist you Monday through Friday from 8:00am – 8:00pm and Saturday from 9:00am – 2:00pm Eastern Time.',
                    type: 'paragraph'
                }
            ]
        }
    },
    {
        status: 'statusLossMitigationRepaymentPlan',
        logEvent: {
            screen: {
                type: 'Dashboard Screen',
                action: 'LossMitigationRPDashboardDisplayed',
                description: 'Dashboard displayed for Loss Mitigation with Repayment Plan'
            }
        },
        popupTemplate: {
            metadata: {
                slotProps: {
                    root: {
                        sx: {
                            '.MuiDialogTitle-root': {
                                fontFamily: 'Poppins',
                                fontWeight: '400 !important'
                            },
                            '.MuiDialogContent-root': {
                                padding: '0px !important'
                            }
                        }
                    },
                    paragraph: {
                        variant: 'paragraph',
                        sx: {
                            color: '#536371',
                            textAlign: 'left',
                            margin: '2rem !important',
                            '& b': {
                                color: '#12202C',
                                fontWeight: '500'
                            },
                            '& u': {
                                color: '#00476A',
                                fontWeight: '500',
                                display: {
                                    xs: 'none',
                                    sm: 'inline-block',
                                    md: 'inline-block',
                                    lg: 'inline-block',
                                    xl: 'inline-block'
                                }
                            },
                            '& a': {
                                color: '#00476A',
                                fontWeight: '500',
                                display: {
                                    xs: 'inline-block',
                                    sm: 'none',
                                    md: 'none',
                                    lg: 'none',
                                    xl: 'none'
                                }
                            }
                        }
                    },
                    heading: {
                        variant: 'subtitle1',
                        sx: {
                            fontFamily: 'Poppins',
                            fontWeight: '600 !important',
                            textAlign: 'center',
                            margin: '0 32px',
                            color: '#12202C'
                        }
                    },
                    subHeading: {
                        variant: 'subtitle2',
                        sx: {
                            color: '#12202C',
                            fontWeight: '600 !important',
                            margin: '2rem 2rem 0 !important',
                            textAlign: 'left',
                            fontFamily: 'Poppins'
                        }
                    },
                    icon: {
                        sx: {
                            width: '200px',
                            height: '61.35px',
                            marginTop: '64px',
                            marginBottom: '32px',
                            justifyContent: 'center'
                        }
                    },
                    buttonCTA1: {
                        sx: {
                            color: '#FFFFFF',
                            fontFamily: 'Poppins !important',
                            width: {
                                xs: '100%',
                                sm: 'auto'
                            }
                        }
                    }
                }
            },
            body: [
                {
                    type: 'icon',
                    content: 'FreedomGold'
                },
                {
                    type: 'heading',
                    content: 'Your Account Is Active In Loss Mitigation With a Repayment Plan In Place'
                },
                {
                    type: 'subHeading',
                    content: 'If you would like to schedule an additional payment, select "Pay Now" to make a one time payment.'
                },
                {
                    content:
                        'If you have any questions or require further assistance, please <b>call Freedom Customer Care Department at</b> <a class="tag-event" href="tel:855-690-5900">855-690-5900</a><u>855-690-5900</u>. Our representatives are available to assist you Monday through Friday from 8:00am – 8:00pm and Saturday from 9:00am – 2:00pm Eastern Time.',
                    type: 'paragraph'
                }
            ]
        }
    },
    {
        status: 'ActiveLossMitigationForeclosureHold',
        logEvent: {
            screen: {
                type: 'Dashboard Screen',
                action: 'ActiveLossMitigationForeclosureHoldDashboardDisplayed',
                description: 'Dashboard displayed for Active Loss Mitigation Foreclosure Hold'
            }
        },
        popupTemplate: {
            metadata: {
                slotProps: {
                    root: {
                        sx: {
                            '.MuiDialogTitle-root': {
                                fontFamily: 'Poppins',
                                fontWeight: '400 !important'
                            },
                            '.MuiDialogContent-root': {
                                padding: '0px !important'
                            }
                        }
                    },
                    paragraph: {
                        variant: 'paragraph',
                        sx: {
                            color: '#536371',
                            textAlign: 'left',
                            margin: '2rem !important',
                            '& b': {
                                color: '#12202C',
                                fontWeight: '500'
                            },
                            '& u': {
                                color: '#00476A',
                                fontWeight: '500'
                            }
                        }
                    },
                    multiparagraph: {
                        variant: 'paragraph',
                        sx: {
                            color: '#536371',
                            textAlign: 'left',
                            margin: '0 2rem 2rem !important',
                            '& b': {
                                color: '#12202C',
                                fontWeight: '500'
                            },
                            '& u': {
                                color: '#00476A',
                                fontWeight: '500'
                            }
                        }
                    },
                    heading: {
                        variant: 'subtitle1',
                        sx: {
                            fontFamily: 'Poppins',
                            fontWeight: '600 !important',
                            textAlign: 'center',
                            margin: '0 32px',
                            color: '#12202C'
                        }
                    },
                    icon: {
                        sx: {
                            width: '200px',
                            height: '61.35px',
                            marginTop: '64px',
                            marginBottom: '32px',
                            justifyContent: 'center'
                        }
                    },
                    buttonCTA1: {
                        sx: {
                            color: '#FFFFFF',
                            fontFamily: 'Poppins !important',
                            width: {
                                xs: '100%',
                                sm: 'auto'
                            }
                        }
                    }
                }
            },
            body: [
                {
                    type: 'icon',
                    content: 'FreedomGold'
                },
                {
                    type: 'heading',
                    content: 'Active Loss Mitigation Foreclosure Hold'
                },
                {
                    content:
                        'Your account status indicates that you recently applied for loss mitigation assistance. As a result, <b>certain account functions may not be available at this time.</b>',
                    type: 'paragraph'
                }
            ]
        }
    },
    {
        status: 'statusForeclosed',
        logEvent: {
            screen: {
                type: 'Dashboard Screen',
                action: 'ForeclosedDashboardDisplayed',
                description: 'Dashboard displayed for Foreclosed'
            }
        },
        popupTemplate: {
            metadata: {
                slotProps: {
                    root: {
                        sx: {
                            '.MuiDialogTitle-root': {
                                fontFamily: 'Poppins',
                                fontWeight: '400 !important'
                            },
                            '.MuiDialogContent-root': {
                                padding: '0px !important'
                            }
                        }
                    },
                    paragraph: {
                        variant: 'paragraph',
                        sx: {
                            color: '#536371',
                            textAlign: 'left',
                            margin: '2rem !important',
                            '& b': {
                                color: '#12202C',
                                fontWeight: '500'
                            },
                            '& u': {
                                color: '#00476A',
                                fontWeight: '500',
                                display: {
                                    xs: 'none',
                                    sm: 'inline-block',
                                    md: 'inline-block',
                                    lg: 'inline-block',
                                    xl: 'inline-block'
                                }
                            },
                            '& a': {
                                color: '#00476A',
                                fontWeight: '500',
                                display: {
                                    xs: 'inline-block',
                                    sm: 'none',
                                    md: 'none',
                                    lg: 'none',
                                    xl: 'none'
                                }
                            }
                        }
                    },
                    multiparagraph: {
                        variant: 'paragraph',
                        sx: {
                            color: '#536371',
                            textAlign: 'left',
                            margin: '0 2rem 2rem !important',
                            '& b': {
                                color: '#12202C',
                                fontWeight: '500'
                            },
                            '& u': {
                                color: '#00476A',
                                fontWeight: '500'
                            }
                        }
                    },
                    heading: {
                        variant: 'subtitle1',
                        sx: {
                            fontFamily: 'Poppins',
                            fontWeight: '600 !important',
                            textAlign: 'center',
                            margin: '0 32px',
                            color: '#12202C'
                        }
                    },
                    icon: {
                        sx: {
                            width: '200px',
                            height: '61.35px',
                            marginTop: '64px',
                            marginBottom: '32px',
                            justifyContent: 'center'
                        }
                    },
                    buttonCTA1: {
                        sx: {
                            color: '#FFFFFF',
                            fontFamily: 'Poppins !important',
                            width: {
                                xs: '100%',
                                sm: 'auto'
                            }
                        }
                    }
                }
            },
            body: [
                {
                    type: 'icon',
                    content: 'FreedomGold'
                },
                {
                    type: 'heading',
                    content: 'This Account Is No Longer Active'
                },
                {
                    content:
                        'If you have any questions, please <b>contact Freedom Customer Care at</b> <a class="tag-event" href="tel:855-690-5900">855-690-5900</a><u>855-690-5900</u>. Our representatives are available to assist you Monday through Friday from 8:00am – 8:00pm and Saturday from 9:00am – 2:00pm Eastern Time.',
                    type: 'paragraph'
                }
            ]
        }
    },
    {
        status: 'activeForeclosure',
        logEvent: {
            screen: {
                type: 'Dashboard Screen',
                action: 'ActiveForeclosureDashboardDisplayed',
                description: 'Dashboard displayed for Active Foreclosure'
            }
        },
        popupTemplate: {
            metadata: {
                slotProps: {
                    root: {
                        sx: {
                            '.MuiDialogTitle-root': {
                                fontFamily: 'Poppins',
                                fontWeight: '400 !important'
                            },
                            '.MuiDialogContent-root': {
                                padding: '0px !important'
                            }
                        }
                    },
                    paragraph: {
                        variant: 'paragraph',
                        sx: {
                            color: '#536371',
                            textAlign: 'left',
                            margin: '2rem !important',
                            '& b': {
                                color: '#12202C',
                                fontWeight: '500'
                            },
                            '& u': {
                                color: '#00476A',
                                fontWeight: '500',
                                display: {
                                    xs: 'none',
                                    sm: 'inline-block',
                                    md: 'inline-block',
                                    lg: 'inline-block',
                                    xl: 'inline-block'
                                }
                            },
                            '& a': {
                                color: '#00476A',
                                fontWeight: '500',
                                display: {
                                    xs: 'inline-block',
                                    sm: 'none',
                                    md: 'none',
                                    lg: 'none',
                                    xl: 'none'
                                }
                            }
                        }
                    },
                    multiparagraph: {
                        variant: 'paragraph',
                        sx: {
                            color: '#536371',
                            textAlign: 'left',
                            margin: '0 2rem 2rem !important',
                            '& b': {
                                color: '#12202C',
                                fontWeight: '500'
                            },
                            '& u': {
                                color: '#00476A',
                                fontWeight: '500'
                            }
                        }
                    },
                    heading: {
                        variant: 'subtitle1',
                        sx: {
                            fontFamily: 'Poppins',
                            fontWeight: '600 !important',
                            textAlign: 'center',
                            margin: '0 32px',
                            color: '#12202C'
                        }
                    },
                    icon: {
                        sx: {
                            width: '200px',
                            height: '61.35px',
                            marginTop: '64px',
                            marginBottom: '32px',
                            justifyContent: 'center'
                        }
                    },
                    buttonCTA1: {
                        sx: {
                            color: '#FFFFFF',
                            fontFamily: 'Poppins !important',
                            width: {
                                xs: '100%',
                                sm: 'auto'
                            }
                        }
                    }
                }
            },
            body: [
                {
                    type: 'icon',
                    content: 'FreedomGold'
                },
                {
                    type: 'heading',
                    content: 'Your Account Is Active In Foreclosure'
                },
                {
                    content:
                        'If you have any questions or require further assistance, please <b>call Freedom Customer Care Department at</b> <a class="tag-event" href="tel:855-690-5900">855-690-5900</a><u>855-690-5900</u>. Our representatives are available to assist you Monday through Friday from 8:00am – 8:00pm and Saturday from 9:00am – 2:00pm Eastern Time.',
                    type: 'paragraph'
                }
            ]
        }
    },
    {
        status: 'statusSevereDel',
        logEvent: {
            screen: {
                type: 'Dashboard Screen',
                action: 'SeverelyDelinquentDashboardDisplayed',
                description: 'Dashboard displayed for Severely Delinquent'
            }
        },
        popupTemplate: {
            metadata: {
                slotProps: {
                    root: {
                        sx: {
                            '.MuiDialogTitle-root': {
                                fontFamily: 'Poppins',
                                fontWeight: '400 !important'
                            },
                            '.MuiDialogContent-root': {
                                padding: '0px !important'
                            }
                        }
                    },
                    paragraph: {
                        variant: 'paragraph',
                        sx: {
                            color: '#536371',
                            textAlign: 'left',
                            margin: '2rem !important',
                            '& b': {
                                color: '#12202C',
                                fontWeight: '500'
                            },
                            '& u': {
                                color: '#00476A',
                                fontWeight: '500'
                            }
                        }
                    },
                    multiparagraph: {
                        variant: 'paragraph',
                        sx: {
                            color: '#536371',
                            textAlign: 'left',
                            margin: '0 2rem 2rem !important',
                            '& b': {
                                color: '#12202C',
                                fontWeight: '500'
                            },
                            '& u': {
                                color: '#00476A',
                                fontWeight: '500',
                                display: {
                                    xs: 'none',
                                    sm: 'inline-block',
                                    md: 'inline-block',
                                    lg: 'inline-block',
                                    xl: 'inline-block'
                                }
                            },
                            '& a': {
                                color: '#00476A',
                                fontWeight: '500',
                                display: {
                                    xs: 'inline-block',
                                    sm: 'none',
                                    md: 'none',
                                    lg: 'none',
                                    xl: 'none'
                                }
                            }
                        }
                    },
                    heading: {
                        variant: 'subtitle1',
                        sx: {
                            fontFamily: 'Poppins',
                            fontWeight: '600 !important',
                            textAlign: 'center',
                            margin: '0 32px',
                            color: '#12202C'
                        }
                    },
                    subHeading: {
                        variant: 'subtitle2',
                        sx: {
                            color: '#12202C',
                            fontWeight: '600 !important',
                            margin: '2rem 2rem 0 !important',
                            textAlign: 'left',
                            fontFamily: 'Poppins'
                        }
                    },
                    icon: {
                        sx: {
                            width: '200px',
                            height: '61.35px',
                            marginTop: '64px',
                            marginBottom: '32px',
                            justifyContent: 'center'
                        }
                    },
                    buttonCTA1: {
                        sx: {
                            color: '#FFFFFF',
                            fontFamily: 'Poppins !important',
                            width: {
                                xs: '100%',
                                sm: 'auto'
                            }
                        }
                    }
                }
            },
            body: [
                {
                    type: 'icon',
                    content: 'FreedomGold'
                },
                {
                    type: 'heading',
                    content: 'Your Account Is Delinquent'
                },
                {
                    type: 'subHeading',
                    content: 'You will need to schedule a payment. Select "Pay Now" to make a one time payment.'
                },
                {
                    content:
                        'If you are experiencing financial difficulties, please <b>go to the Help Center</b> to obtain information about loss mitigation options that may be available.',
                    type: 'paragraph'
                },
                {
                    content:
                        'If you have any questions or require further assistance, please <b>call Freedom Customer Care Department at</b> <a class="tag-event" href="tel:855-690-5900">855-690-5900</a><u>855-690-5900</u>. Our representatives are available to assist you Monday through Friday from 8:00am – 8:00pm and Saturday from 9:00am – 2:00pm Eastern Time.',
                    type: 'multiparagraph'
                }
            ]
        }
    },
    {
        status: 'statusDelinquent',
        logEvent: {
            screen: {
                type: 'Dashboard Screen',
                action: 'DelinquentDashboardDisplayed',
                description: 'Dashboard displayed for Delinquent'
            }
        },
        popupTemplate: {
            metadata: {
                slotProps: {
                    root: {
                        sx: {
                            '.MuiDialogTitle-root': {
                                fontFamily: 'Poppins',
                                fontWeight: '400 !important'
                            },
                            '.MuiDialogContent-root': {
                                padding: '0px !important'
                            }
                        }
                    },
                    paragraph: {
                        variant: 'paragraph',
                        sx: {
                            color: '#536371',
                            textAlign: 'left',
                            margin: '2rem !important',
                            '& b': {
                                color: '#12202C',
                                fontWeight: '500'
                            },
                            '& u': {
                                color: '#00476A',
                                fontWeight: '500'
                            }
                        }
                    },
                    multiparagraph: {
                        variant: 'paragraph',
                        sx: {
                            color: '#536371',
                            textAlign: 'left',
                            margin: '0 2rem 2rem !important',
                            '& b': {
                                color: '#12202C',
                                fontWeight: '500'
                            },
                            '& u': {
                                color: '#00476A',
                                fontWeight: '500',
                                display: {
                                    xs: 'none',
                                    sm: 'inline-block',
                                    md: 'inline-block',
                                    lg: 'inline-block',
                                    xl: 'inline-block'
                                }
                            },
                            '& a': {
                                color: '#00476A',
                                fontWeight: '500',
                                display: {
                                    xs: 'inline-block',
                                    sm: 'none',
                                    md: 'none',
                                    lg: 'none',
                                    xl: 'none'
                                }
                            }
                        }
                    },
                    heading: {
                        variant: 'subtitle1',
                        sx: {
                            fontFamily: 'Poppins',
                            fontWeight: '600 !important',
                            textAlign: 'center',
                            margin: '0 32px',
                            color: '#12202C'
                        }
                    },
                    subHeading: {
                        variant: 'subtitle2',
                        sx: {
                            color: '#12202C',
                            fontWeight: '600 !important',
                            margin: '2rem 2rem 0 !important',
                            textAlign: 'left',
                            fontFamily: 'Poppins'
                        }
                    },
                    icon: {
                        sx: {
                            width: '200px',
                            height: '61.35px',
                            marginTop: '64px',
                            marginBottom: '32px',
                            justifyContent: 'center'
                        }
                    },
                    buttonCTA1: {
                        sx: {
                            color: '#FFFFFF',
                            fontFamily: 'Poppins !important',
                            width: {
                                xs: '100%',
                                sm: 'auto'
                            }
                        }
                    }
                }
            },
            body: [
                {
                    type: 'icon',
                    content: 'FreedomGold'
                },
                {
                    type: 'heading',
                    content: 'Your Account Is Delinquent'
                },
                {
                    type: 'subHeading',
                    content: 'You will need to schedule a payment. Select "Pay Now" to make a one-time payment.'
                },
                {
                    content:
                        'If you are experiencing financial difficulties, please <b>go to the Help Center</b> to obtain information about loss mitigation options that may be available.',
                    type: 'paragraph'
                },
                {
                    content:
                        'If you have any questions or require further assistance, please <b>call Freedom Customer Care Department at</b> <a class="tag-event" href="tel:855-690-5900">855-690-5900</a><u>855-690-5900</u>. Our representatives are available to assist you Monday through Friday from 8:00am – 8:00pm and Saturday from 9:00am – 2:00pm Eastern Time.',
                    type: 'multiparagraph'
                }
            ]
        }
    },
    {
        status: 'statusSevereDelRP',
        logEvent: {
            screen: {
                type: 'Dashboard Screen',
                action: 'SeverelyDelinquentRPDashboardDisplayed',
                description: 'Dashboard displayed for Severely Delinquent with Replayment Plan'
            }
        },
        popupTemplate: {
            metadata: {
                slotProps: {
                    root: {
                        sx: {
                            '.MuiDialogTitle-root': {
                                fontFamily: 'Poppins',
                                fontWeight: '400 !important'
                            },
                            '.MuiDialogContent-root': {
                                padding: '0px !important'
                            }
                        }
                    },
                    paragraph: {
                        variant: 'paragraph',
                        sx: {
                            color: '#536371',
                            textAlign: 'left',
                            margin: '2rem !important',
                            '& b': {
                                color: '#12202C',
                                fontWeight: '500'
                            },
                            '& u': {
                                color: '#00476A',
                                fontWeight: '500',
                                display: {
                                    xs: 'none',
                                    sm: 'inline-block',
                                    md: 'inline-block',
                                    lg: 'inline-block',
                                    xl: 'inline-block'
                                }
                            },
                            '& a': {
                                color: '#00476A',
                                fontWeight: '500',
                                display: {
                                    xs: 'inline-block',
                                    sm: 'none',
                                    md: 'none',
                                    lg: 'none',
                                    xl: 'none'
                                }
                            }
                        }
                    },
                    heading: {
                        variant: 'subtitle1',
                        sx: {
                            fontFamily: 'Poppins',
                            fontWeight: '600 !important',
                            textAlign: 'center',
                            margin: '0 32px',
                            color: '#12202C'
                        }
                    },
                    subHeading: {
                        variant: 'subtitle2',
                        sx: {
                            color: '#12202C',
                            fontWeight: '600 !important',
                            margin: '2rem 2rem 0 !important',
                            textAlign: 'left',
                            fontFamily: 'Poppins'
                        }
                    },
                    icon: {
                        sx: {
                            width: '200px',
                            height: '61.35px',
                            marginTop: '64px',
                            marginBottom: '32px',
                            justifyContent: 'center'
                        }
                    },
                    buttonCTA1: {
                        sx: {
                            color: '#FFFFFF',
                            fontFamily: 'Poppins !important',
                            width: {
                                xs: '100%',
                                sm: 'auto'
                            }
                        }
                    }
                }
            },
            body: [
                {
                    type: 'icon',
                    content: 'FreedomGold'
                },
                {
                    type: 'heading',
                    content: 'Your Account Is Delinquent With a Repayment Plan In Place'
                },
                {
                    type: 'subHeading',
                    content: 'If you would like to schedule an additional payment, select "Pay Now" to make a one time payment.'
                },
                {
                    content:
                        'If you have any questions or require further assistance, please <b>call Freedom Customer Care Department at</b> <a class="tag-event" href="tel:855-690-5900">855-690-5900</a><u>855-690-5900</u>. Our representatives are available to assist you Monday through Friday from 8:00am – 8:00pm and Saturday from 9:00am – 2:00pm Eastern Time.',
                    type: 'paragraph'
                }
            ]
        }
    },
    {
        status: 'statusDelinquentRP',
        logEvent: {
            screen: {
                type: 'Dashboard Screen',
                action: 'DelinquentRPDashboardDisplayed',
                description: 'Dashboard displayed for Delinquent with Replayment Plan'
            }
        },
        popupTemplate: {
            metadata: {
                slotProps: {
                    root: {
                        sx: {
                            '.MuiDialogTitle-root': {
                                fontFamily: 'Poppins',
                                fontWeight: '400 !important'
                            },
                            '.MuiDialogContent-root': {
                                padding: '0px !important'
                            }
                        }
                    },
                    paragraph: {
                        variant: 'paragraph',
                        sx: {
                            color: '#536371',
                            textAlign: 'left',
                            margin: '2rem !important',
                            '& b': {
                                color: '#12202C',
                                fontWeight: '500'
                            },
                            '& u': {
                                color: '#00476A',
                                fontWeight: '500',
                                display: {
                                    xs: 'none',
                                    sm: 'inline-block',
                                    md: 'inline-block',
                                    lg: 'inline-block',
                                    xl: 'inline-block'
                                }
                            },
                            '& a': {
                                color: '#00476A',
                                fontWeight: '500',
                                display: {
                                    xs: 'inline-block',
                                    sm: 'none',
                                    md: 'none',
                                    lg: 'none',
                                    xl: 'none'
                                }
                            }
                        }
                    },
                    heading: {
                        variant: 'subtitle1',
                        sx: {
                            fontFamily: 'Poppins',
                            fontWeight: '600 !important',
                            textAlign: 'center',
                            margin: '0 32px',
                            color: '#12202C'
                        }
                    },
                    subHeading: {
                        variant: 'subtitle2',
                        sx: {
                            color: '#12202C',
                            fontWeight: '600 !important',
                            margin: '2rem 2rem 0 !important',
                            textAlign: 'left',
                            fontFamily: 'Poppins'
                        }
                    },
                    icon: {
                        sx: {
                            width: '200px',
                            height: '61.35px',
                            marginTop: '64px',
                            marginBottom: '32px',
                            justifyContent: 'center'
                        }
                    },
                    buttonCTA1: {
                        sx: {
                            color: '#FFFFFF',
                            fontFamily: 'Poppins !important',
                            width: {
                                xs: '100%',
                                sm: 'auto'
                            }
                        }
                    }
                }
            },
            body: [
                {
                    type: 'icon',
                    content: 'FreedomGold'
                },
                {
                    type: 'heading',
                    content: 'Your Account Is Delinquent With a Repayment Plan In Place'
                },
                {
                    type: 'subHeading',
                    content: 'If you would like to schedule an additional payment, select "Pay Now" to make a one time payment.'
                },
                {
                    content:
                        'If you have any questions or require further assistance, please <b>call Freedom Customer Care Department at</b> <a class="tag-event" href="tel:855-690-5900">855-690-5900</a><u>855-690-5900</u>. Our representatives are available to assist you Monday through Friday from 8:00am – 8:00pm and Saturday from 9:00am – 2:00pm Eastern Time.',
                    type: 'paragraph'
                }
            ]
        }
    },
    {
        status: 'PaidOffStatus',
        logEvent: {
            screen: {
                type: 'Dashboard Screen',
                action: 'PaidOffDashboardDisplayed',
                description: 'Dashboard displayed for Paid Off'
            }
        },
        popupTemplate: {
            metadata: {
                slotProps: {
                    root: {
                        sx: {
                            '.MuiDialogTitle-root': {
                                fontFamily: 'Poppins',
                                fontWeight: '400 !important'
                            },
                            '.MuiDialogContent-root': {
                                padding: '0px !important'
                            }
                        }
                    },
                    paragraph: {
                        variant: 'paragraph',
                        sx: {
                            color: '#536371',
                            textAlign: 'left',
                            margin: '2rem !important',
                            '& b': {
                                color: '#12202C',
                                fontWeight: '500'
                            },
                            '& u': {
                                color: '#00476A',
                                fontWeight: '500'
                            }
                        }
                    },
                    multiparagraph: {
                        variant: 'paragraph',
                        sx: {
                            color: '#536371',
                            textAlign: 'left',
                            margin: '0 2rem 2rem !important',
                            '& b': {
                                color: '#12202C',
                                fontWeight: '500'
                            },
                            '& u': {
                                color: '#00476A',
                                fontWeight: '500'
                            },
                            '& a': {
                                color: '#00476A',
                                fontWeight: '500'
                            }
                        }
                    },
                    heading: {
                        variant: 'subtitle1',
                        sx: {
                            fontFamily: 'Poppins',
                            fontWeight: '600 !important',
                            textAlign: 'center',
                            margin: '0 32px',
                            color: '#12202C'
                        }
                    },
                    icon: {
                        sx: {
                            width: '200px',
                            height: '61.35px',
                            marginTop: '64px',
                            marginBottom: '32px',
                            justifyContent: 'center'
                        }
                    },
                    buttonCTA1: {
                        sx: {
                            color: '#FFFFFF',
                            fontFamily: 'Poppins !important',
                            width: {
                                xs: '100%',
                                sm: 'auto'
                            }
                        }
                    }
                }
            },
            body: [
                {
                    type: 'icon',
                    content: 'FreedomGold'
                },
                {
                    type: 'heading',
                    content: 'Your Account Is Paid In Full'
                },
                {
                    content: 'We thank you for being a great customer.',
                    type: 'paragraph'
                },
                {
                    content:
                        '<b>Please consider us for your future loan financing needs by navigating to <u><a href="https://www.freedommortgage.com/" target="_blank">www.freedommortgage.com</a></u></b>',
                    type: 'multiparagraph'
                }
            ]
        }
    },
    {
        status: 'InactiveStatus',
        logEvent: {
            screen: {
                type: 'Dashboard Screen',
                action: 'InactiveDashboardDisplayed',
                description: 'Dashboard displayed for Inactive'
            }
        },
        popupTemplate: {
            metadata: {
                slotProps: {
                    root: {
                        sx: {
                            '.MuiDialogTitle-root': {
                                fontFamily: 'Poppins',
                                fontWeight: '400 !important'
                            },
                            '.MuiDialogContent-root': {
                                padding: '0px !important'
                            }
                        }
                    },
                    paragraph: {
                        variant: 'paragraph',
                        sx: {
                            color: '#536371',
                            textAlign: 'left',
                            margin: '2rem !important',
                            '& b': {
                                color: '#12202C',
                                fontWeight: '500'
                            },
                            '& u': {
                                color: '#00476A',
                                fontWeight: '500',
                                display: {
                                    xs: 'none',
                                    sm: 'inline-block',
                                    md: 'inline-block',
                                    lg: 'inline-block',
                                    xl: 'inline-block'
                                }
                            },
                            '& a': {
                                color: '#00476A',
                                fontWeight: '500',
                                display: {
                                    xs: 'inline-block',
                                    sm: 'none',
                                    md: 'none',
                                    lg: 'none',
                                    xl: 'none'
                                }
                            }
                        }
                    },
                    heading: {
                        variant: 'subtitle1',
                        sx: {
                            fontFamily: 'Poppins',
                            fontWeight: '600 !important',
                            textAlign: 'center',
                            margin: '0 32px',
                            color: '#12202C'
                        }
                    },
                    icon: {
                        sx: {
                            width: '200px',
                            height: '61.35px',
                            marginTop: '64px',
                            marginBottom: '32px',
                            justifyContent: 'center'
                        }
                    },
                    buttonCTA1: {
                        sx: {
                            color: '#FFFFFF',
                            fontFamily: 'Poppins !important',
                            width: {
                                xs: '100%',
                                sm: 'auto'
                            }
                        }
                    }
                }
            },
            body: [
                {
                    type: 'icon',
                    content: 'FreedomGold'
                },
                {
                    type: 'heading',
                    content: 'This Account Is No Longer Active'
                },
                {
                    content:
                        'If you have any questions, please <b>contact Freedom Customer Care at</b> <a class="tag-event" href="tel:855-690-5900">855-690-5900</a><u>855-690-5900</u>. Our representatives are available to assist you Monday through Friday from 8:00am – 8:00pm and Saturday from 9:00am – 2:00pm Eastern Time.',
                    type: 'paragraph'
                }
            ]
        }
    },
    {
        status: 'statusServiceReleased',
        logEvent: {
            screen: {
                type: 'Dashboard Screen',
                action: 'ServiceReleasedDashboardDisplayed',
                description: 'Dashboard displayed for Service Released'
            }
        },
        popupTemplate: {
            metadata: {
                slotProps: {
                    root: {
                        sx: {
                            '.MuiDialogTitle-root': {
                                fontFamily: 'Poppins',
                                fontWeight: '400 !important'
                            },
                            '.MuiDialogContent-root': {
                                padding: '0px !important'
                            }
                        }
                    },
                    paragraph: {
                        variant: 'paragraph',
                        sx: {
                            color: '#536371',
                            textAlign: 'left',
                            margin: '2rem !important',
                            '& b': {
                                color: '#12202C',
                                fontWeight: '500'
                            },
                            '& u': {
                                color: '#00476A',
                                fontWeight: '500',
                                display: {
                                    xs: 'none',
                                    sm: 'inline-block',
                                    md: 'inline-block',
                                    lg: 'inline-block',
                                    xl: 'inline-block'
                                }
                            },
                            '& a': {
                                color: '#00476A',
                                fontWeight: '500',
                                display: {
                                    xs: 'inline-block',
                                    sm: 'none',
                                    md: 'none',
                                    lg: 'none',
                                    xl: 'none'
                                }
                            }
                        }
                    },
                    heading: {
                        variant: 'subtitle1',
                        sx: {
                            fontFamily: 'Poppins',
                            fontWeight: '600 !important',
                            textAlign: 'center',
                            margin: '0 32px',
                            color: '#12202C'
                        }
                    },
                    icon: {
                        sx: {
                            width: '200px',
                            height: '61.35px',
                            marginTop: '64px',
                            marginBottom: '32px',
                            justifyContent: 'center'
                        }
                    },
                    buttonCTA1: {
                        sx: {
                            color: '#FFFFFF',
                            fontFamily: 'Poppins !important',
                            width: {
                                xs: '100%',
                                sm: 'auto'
                            }
                        }
                    }
                }
            },
            body: [
                {
                    type: 'icon',
                    content: 'FreedomGold'
                },
                {
                    type: 'heading',
                    content: 'The Servicing Of Your Mortgage Loan Has Been Transferred'
                },
                {
                    content:
                        'If you have any questions or require further assistance, please <b>call Freedom Customer Care Department at</b> <a class="tag-event" href="tel:855-690-5900">855-690-5900</a><u>855-690-5900</u>. Our representatives are available to assist you Monday through Friday from 8:00am – 8:00pm and Saturday from 9:00am – 2:00pm Eastern Time.',
                    type: 'paragraph'
                }
            ]
        }
    },
    {
        status: 'statusPendingServiceRelease',
        logEvent: {
            screen: {
                type: 'Dashboard Screen',
                action: 'PendingServiceReleaseDashboardDisplayed',
                description: 'Dashboard displayed for Pending Service Release'
            }
        },
        popupTemplate: {
            metadata: {
                slotProps: {
                    root: {
                        sx: {
                            '.MuiDialogTitle-root': {
                                fontFamily: 'Poppins',
                                fontWeight: '400 !important'
                            },
                            '.MuiDialogContent-root': {
                                padding: '0px !important'
                            }
                        }
                    },
                    paragraph: {
                        variant: 'paragraph',
                        sx: {
                            color: '#536371',
                            textAlign: 'left',
                            margin: '2rem !important',
                            '& b': {
                                color: '#12202C',
                                fontWeight: '500'
                            },
                            '& u': {
                                color: '#00476A',
                                fontWeight: '500',
                                display: {
                                    xs: 'none',
                                    sm: 'inline-block',
                                    md: 'inline-block',
                                    lg: 'inline-block',
                                    xl: 'inline-block'
                                }
                            },
                            '& a': {
                                color: '#00476A',
                                fontWeight: '500',
                                display: {
                                    xs: 'inline-block',
                                    sm: 'none',
                                    md: 'none',
                                    lg: 'none',
                                    xl: 'none'
                                }
                            }
                        }
                    },
                    heading: {
                        variant: 'subtitle1',
                        sx: {
                            fontFamily: 'Poppins',
                            fontWeight: '600 !important',
                            textAlign: 'center',
                            margin: '0 32px',
                            color: '#12202C'
                        }
                    },
                    icon: {
                        sx: {
                            width: '200px',
                            height: '61.35px',
                            marginTop: '64px',
                            marginBottom: '32px',
                            justifyContent: 'center'
                        }
                    },
                    buttonCTA1: {
                        sx: {
                            color: '#FFFFFF',
                            fontFamily: 'Poppins !important',
                            width: {
                                xs: '100%',
                                sm: 'auto'
                            }
                        }
                    }
                }
            },
            body: [
                {
                    type: 'icon',
                    content: 'FreedomGold'
                },
                {
                    type: 'heading',
                    content: 'Your Account Is Pending Service Release'
                },
                {
                    content:
                        'If you have any questions or require further assistance, please <b>call Freedom Customer Care Department at</b> <a class="tag-event" href="tel:855-690-5900">855-690-5900</a><u>855-690-5900</u>. Our representatives are available to assist you Monday through Friday from 8:00am – 8:00pm and Saturday from 9:00am – 2:00pm Eastern Time.',
                    type: 'paragraph'
                }
            ]
        }
    }
];

export const accountStatusWithoutPopupMessages = [
    {
        status: 'statusCurrent',
        logEvent: {
            screen: {
                type: 'Dashboard Screen',
                action: 'CurrentAcDashboardDisplayed',
                description: 'Dashboard displayed for Current Account'
            }
        }
    },
    {
        status: 'statusPastDue',
        logEvent: {
            screen: {
                type: 'Dashboard Screen',
                action: 'PastDueDashboardDisplayed',
                description: 'Dashboard displayed for Past Due'
            }
        }
    },
    {
        status: 'statusPayDueNow',
        logEvent: {
            screen: {
                type: 'Dashboard Screen',
                action: 'PaymentDueNowDashboardDisplayed',
                description: 'Dashboard displayed for Payment Due Now'
            }
        }
    }
];

export const accountStatusEvents = {
    logEvent: {
        LearnMoreLink: {
            type: 'Learn More',
            action: 'LMLearnMoreDisplayed',
            description: 'Learn More banner clicked'
        },
        CallUs: {
            type: 'Phone Number',
            action: 'LMPhoneNumber',
            description: 'Phone Number clicked from Loan status message'
        }
    }
};
